import { useGetRole } from "@/hooks/useGetRole";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";

export const RecordReadError = () => {
  const { role } = useGetRole();
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/");
  };
  return (
    <div className="flex h-screen">
      <div className="m-auto flex flex-col gap-2" data-testid="error-loading">
        <h3>Error leyendo el expediente (╯°□°)╯︵ ┻━┻</h3>
        <pre className="text-center">{role}</pre>
        <Button variant={"ghost"} onClick={handleNavigate}>
          Regresar
        </Button>
      </div>
    </div>
  );
};
